<template>
    <div class="h-full w-full flex flex-col">
        <RolesFrom mode="edit" :selected-item="selectedItem" @close="$emit('close')" @updated="$emit('updated')" @view-student-profile="viewStudentProfile" />
    </div>
</template>

<script>
import RolesFrom from "./form.vue";
export default {
    name: "roles-edit",
    emits: ["updated"],
    components: { RolesFrom, },
    props: ["selectedItem"],
    methods: {
        viewStudentProfile(studentId) {
            this.$emit('view-student-profile', studentId);
        }
    },
}
</script>